/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Iaso
 * Iaso Swagger
 * OpenAPI spec version: v1
 */
import { z as zod } from 'zod';

export const Status7b5Enum = zod
    .enum([
        'ACCEPTED',
        'REJECTED',
        'SKIPPED',
        'UNKNOWN',
        'SUBMISSION',
        'NEW_VERSION',
    ])
    .describe(
        '\* `ACCEPTED` - Accepted\n\* `REJECTED` - Rejected\n\* `SKIPPED` - Skipped\n\* `UNKNOWN` - Unknown\n\* `SUBMISSION` - Submission\n\* `NEW_VERSION` - New version',
    );

export type Status7b5Enum = zod.input<typeof Status7b5Enum>;
export type Status7b5EnumOutput = zod.output<typeof Status7b5Enum>;
